import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: true
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const string = value ?? '';
    const doc = new DOMParser().parseFromString(string, 'text/html');
    return (doc.body.textContent ?? '').trim();
  }
}
